import { ModuleWithProviders, NgModule } from '@angular/core';
import { ProductEventModule } from './event/product-event.module';
import { ProductStoreModule } from './store/product-store.module';

@NgModule({
  imports: [ProductStoreModule, ProductEventModule],
})
export class ProductModule {
  static forRoot(): ModuleWithProviders<ProductModule> {
    return {
      ngModule: ProductModule,
      providers: [],
    };
  }
}
